<script>
  import CustomerApi from "@thetechdept/shopify-bones-customer-api";
  export let productVariantId;
  export let customerId;
  export let customerIdSignature;
  export let proxy;
  let state;
  let freezeTimeout;

  const addWishlist = async () => {
    state = "adding";

    // If global freeze, keep retrying
    if (window.freeze) {
      // console.log("::Frozen, setting timeout");
      freezeTimeout = setTimeout(() => {
        // console.log("::Retrying");
        addWishlist();
      }, 500);
      return;
    } else {
      // console.log("::Clearing timeout");
      clearTimeout(freezeTimeout);
    }

    // GLOBAL FREEZE VAR for any uber micro DoTa clickers
    // Necessary as it needs to get current wishlists, update the whole array then send it back
    window.freeze = true;

    // console.log("::Adding wishlist of", productVariantId, "for", customerId);

    // Create API instance
    const customerApi = new CustomerApi({
      customerType: "customer", // moot
      customerId,
      customerIdSignature,
      proxy,
    });

    // Reset wishlist override
    // customerApi
    //   .update({
    //     name: "wishlists",
    //     value: [productVariantId]
    //   })
    //   .then(() => {
    // console.log("::Reset wishlist", [productVariantId]);
    //   });

    // Get current wishlists
    customerApi
      .getWishlist()
      .then((wishlists) => {
        // Reduce to just their variant IDs
        const wishlistIds = wishlists ? wishlists.map((f) => f.id) : [];
        // If already added, chill
        if (wishlistIds.includes(productVariantId)) {
          state = "added";
          window.freeze = false;
          return;
        }
        // Add this item to the array and update API
        wishlistIds.push(productVariantId);
        // console.log("::Updating with", wishlistIds);
        customerApi
          .update({
            name: "wishlist",
            value: wishlistIds,
          })
          .then((data) => {
            // console.log("::Updated");
            state = "added";
            window.freeze = false;
          })
          .catch((e) => {
            console.error("Wishlists update error", e);
            state = "erroring";
            window.freeze = false;
          });
      })
      .catch((e) => {
        console.error(`Wishlists get error: ${e.message}`);
        state = "erroring";
        window.freeze = false;
      });
  };
</script>

{#if state === "added"}
  <p class="_added">
    Added to
    <a href="/pages/wishlist">wishlist</a>
  </p>
{:else if state === "adding"}
  <p class="_adding">Adding...</p>
{:else if state === "erroring"}
  <p class="_erroring">Error</p>
{:else}
  <p><button on:click={addWishlist}>Add to wishlist</button></p>
{/if}
